var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUwalk8(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 114,
    viewBox: "0 0 115 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_390_3942)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 12,
    width: 87,
    height: 87,
    rx: 3.40448,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.2387 79.2899C50.9176 79.072 59.0531 84.9731 64.6806 84.8667C70.3081 84.7603 82.0698 81.3031 81.5851 55.4119C81.1004 29.5207 65.1282 26.0179 58.9366 26.1327C29.9496 26.6749 18.5527 79.6767 39.2387 79.2899Z",
    fill: "url(#paint0_linear_390_3942)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.709 75.8447H28.3311V74.1558H31.709V75.8447Z",
    fill: "#D4D8FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4209 75.8447H38.0431V74.1558H41.4209V75.8447Z",
    fill: "#D4D8FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5107 81.7549H33.8218V78.377H35.5107V81.7549Z",
    fill: "#D4D8FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5107 72.0439H33.8218V68.6661H35.5107V72.0439Z",
    fill: "#D4D8FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1326 33.6227C85.5294 33.6227 86.666 34.7593 86.666 36.1561C86.666 37.5528 85.5294 38.6895 84.1326 38.6895C82.7359 38.6895 81.5992 37.5528 81.5992 36.1561C81.5992 34.7593 82.7359 33.6227 84.1326 33.6227ZM84.1326 37.0005C84.5988 37.0005 84.9771 36.6205 84.9771 36.1561C84.9771 35.6916 84.5988 35.3116 84.1326 35.3116C83.6665 35.3116 83.2882 35.6916 83.2882 36.1561C83.2882 36.6205 83.6665 37.0005 84.1326 37.0005Z",
    fill: "#D4D8FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3445 38.6899V56.4236C70.3445 57.8221 69.2095 58.957 67.8111 58.957H71.6111C73.0096 58.957 74.1445 57.8221 74.1445 56.4236V38.6899C74.1445 37.2915 73.0096 36.1566 71.6111 36.1566H67.8111C69.2095 36.1566 70.3445 37.2915 70.3445 38.6899Z",
    fill: "#F7F7F8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2882 45.6701H40.3427C36.361 45.6701 33.1221 42.407 33.1221 38.3956C33.1221 34.3842 36.361 31.1211 40.3427 31.1211H71.2882C75.2699 31.1211 78.5088 34.3842 78.5088 38.3956C78.5088 42.407 75.2699 45.6701 71.2882 45.6701ZM40.3427 34.2387C38.0672 34.2387 36.2166 36.1031 36.2166 38.3956C36.2166 40.6881 38.0672 42.5525 40.3427 42.5525H71.2882C73.5637 42.5525 75.4143 40.6881 75.4143 38.3956C75.4143 36.1031 73.5637 34.2387 71.2882 34.2387H40.3427Z",
    fill: "#433ED1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4361 40.4713C44.5755 40.4713 45.4991 39.5408 45.4991 38.3929C45.4991 37.245 44.5755 36.3145 43.4361 36.3145C42.2967 36.3145 41.373 37.245 41.373 38.3929C41.373 39.5408 42.2967 40.4713 43.4361 40.4713Z",
    fill: "#433ED1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M51.689 40.4713C52.8284 40.4713 53.752 39.5408 53.752 38.3929C53.752 37.245 52.8284 36.3145 51.689 36.3145C50.5496 36.3145 49.626 37.245 49.626 38.3929C49.626 39.5408 50.5496 40.4713 51.689 40.4713Z",
    fill: "#433ED1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2042 57.1018H40.3417C36.3601 57.1018 33.1211 53.8386 33.1211 49.8273C33.1211 47.8964 33.8989 46.0216 35.2543 44.6811C36.5643 43.3363 38.4252 42.5527 40.3417 42.5527H71.2872C73.2966 42.5527 75.209 43.3987 76.5397 44.8723L74.2477 46.9673C73.4926 46.1318 72.4425 45.6704 71.2872 45.6704H40.3417C39.2359 45.6704 38.2065 46.1027 37.4431 46.8863C36.6448 47.6761 36.2156 48.7132 36.2156 49.8273C36.2156 52.1198 38.0662 53.9841 40.3417 53.9841H52.2042V57.1018Z",
    fill: "#433ED1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4361 51.903C44.5755 51.903 45.4991 50.9724 45.4991 49.8245C45.4991 48.6766 44.5755 47.7461 43.4361 47.7461C42.2967 47.7461 41.373 48.6766 41.373 49.8245C41.373 50.9724 42.2967 51.903 43.4361 51.903Z",
    fill: "#433ED1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M51.689 51.903C52.8284 51.903 53.752 50.9724 53.752 49.8245C53.752 48.6766 52.8284 47.7461 51.689 47.7461C50.5496 47.7461 49.626 48.6766 49.626 49.8245C49.626 50.9724 50.5496 51.903 51.689 51.903Z",
    fill: "#433ED1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2042 68.5334H40.3417C36.3601 68.5334 33.1211 65.2703 33.1211 61.2589C33.1211 59.328 33.8989 57.4533 35.2543 56.1127C36.5643 54.7679 38.4252 53.9844 40.3417 53.9844H51.1726V57.102H40.3417C39.2359 57.102 38.2065 57.5343 37.4431 58.3179C36.6448 59.1077 36.2156 60.1449 36.2156 61.2589C36.2156 63.5514 38.0662 65.4158 40.3417 65.4158H52.2042V68.5334Z",
    fill: "#433ED1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4361 63.3346C44.5755 63.3346 45.4991 62.404 45.4991 61.2562C45.4991 60.1083 44.5755 59.1777 43.4361 59.1777C42.2967 59.1777 41.373 60.1083 41.373 61.2562C41.373 62.404 42.2967 63.3346 43.4361 63.3346Z",
    fill: "#433ED1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M51.689 63.3346C52.8284 63.3346 53.752 62.404 53.752 61.2562C53.752 60.1083 52.8284 59.1777 51.689 59.1777C50.5496 59.1777 49.626 60.1083 49.626 61.2562C49.626 62.404 50.5496 63.3346 51.689 63.3346Z",
    fill: "#433ED1"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2561 78.9229C70.0416 78.9229 69.8291 78.8792 69.629 78.7899C69.1503 78.5758 57.8779 73.4317 57.8779 62.8898V54.7237C57.8779 54.0378 58.3215 53.433 58.9713 53.2334L69.8023 49.8934C70.0973 49.7999 70.415 49.7999 70.7079 49.8934L81.5389 53.2334C82.1887 53.433 82.6323 54.0378 82.6323 54.7237V62.8898C82.6323 73.4317 71.3598 78.5758 70.8812 78.7878C70.6832 78.8792 70.4707 78.9229 70.2561 78.9229ZM60.9725 55.8772V62.8898C60.9725 70.1519 68.0734 74.4688 70.2541 75.6244C72.4326 74.4646 79.5398 70.1249 79.5398 62.8898V55.8772L70.2561 53.0131L60.9725 55.8772Z",
    fill: "#433ED1"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2252 68.5333C68.8147 68.5333 68.4206 68.3691 68.1318 68.076L64.5215 64.4387L66.7104 62.2335L69.186 64.7256L74.7975 58.6357L77.0668 60.7578L70.3619 68.0324C70.0752 68.34 69.677 68.5208 69.2561 68.5291C69.2438 68.5333 69.2355 68.5333 69.2252 68.5333Z",
    fill: "#433ED1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_390_3942",
    x: 0.722534,
    y: 0.0843256,
    width: 113.555,
    height: 113.555,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.36179
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.63873
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_390_3942"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_390_3942",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_390_3942",
    x1: 55.1436,
    y1: 84.8682,
    x2: 55.1436,
    y2: 26.1301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F2FF",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUwalk8);
export default __webpack_public_path__ + "static/media/uwalk8.fb05f8e6704a3ce7873f4396a0dac2a6.svg";
export { ForwardRef as ReactComponent };